"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_admin_1 = require("react-admin");
/**
 * The React component for React-admin's TextField. Allows to pass translations function that
 * should handle the source text, and optional namespace to use.
 *
 * @component
 * @example
 * ```tsx
 * <TextFieldWithTranslation source="type" t={t} ns="namespace"/>
 * ```
 *
 * @param {object} props - Properties passed to the component (this includes TextField props).
 * @property {TFunction} props.t - The translation function that should handle translation of the source text.
 * @property {string} [props.ns] - The namespace where key lookup should be performed. If not provided, the "translation" namespace will be used.
 * @property {string} [props.source] - The source property from the record object to be displayed as text.
 *
 * @returns {ReactElement} The React component for React-admin's TextField with translation capability.

 */
var TextFieldWithTranslation = function (_a) {
    var _b;
    var source = _a.source, t = _a.t, _c = _a.ns, ns = _c === void 0 ? "translation" : _c, rest = __rest(_a, ["source", "t", "ns"]);
    var record = (0, react_admin_1.useRecordContext)();
    var originalText = record[source];
    var modifiedText = "".concat(t("".concat(ns, ":").concat(originalText)));
    return react_1.default.createElement(react_admin_1.TextField, __assign({ source: source, record: __assign(__assign({}, record), (_b = {}, _b[source] = modifiedText, _b)) }, rest));
};
exports.default = TextFieldWithTranslation;
